// Copyright (C) 2026 FlexiProof. All rights reserved.
//
// This source code file is a part of free software licensed under the terms of
// the MIT License as published by the Massachusetts Institute of Technology:
// you can use, copy, modify and distribute any part of it without limitation,
// subject to the conditions contained within that license.
//
// This source code file, and the software it forms a part of, IS PROVIDED "AS
// IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED. See the MIT License
// for more details.
//
// You should have received a copy of the MIT License along with this source
// code file in the root of this repository. If not, see one of the following
// 3rd party sites for a copy of the license template:
// - <https://opensource.org/licenses/MIT>
// - <https://choosealicense.com/licenses/mit>
// - <https://spdx.org/licenses/MIT>

/**
 * @file Load start screen for 
 * @author James Reid
 */

// @ts-check

// @@imports-package
import { App } from "../app/index.js"
import { SteppedContainer } from "../components/index.js"

import { Layout } from "./Layout.js"

// @@imports-utils
import { cloneTemplate } from "../utils/index.js"

// @@imports-types
import { STEP_TYPES } from "../types/StepType.js"

// @@body
const startScreen = new Layout(async () => {
    const { container } = App.instance

    const dummy = SteppedContainer.createContainer("content")
    const content = SteppedContainer.createContainer("content")
    const startScreen = App.state.deck.type === "shed"
        ? cloneTemplate("start-screen-shed")
        : cloneTemplate("start-screen")
    content.append(startScreen)

    const popover = SteppedContainer.createContainer("popover")
    const nav = cloneTemplate("start-screen-popover")
    popover.append(nav)

    nav.querySelector("button.primary")
        ?.addEventListener("click", () => {
            const modalContainer = SteppedContainer.modalContainer()
            const modal = cloneTemplate("start-screen-declaration-modal")
            modal.querySelector("button.primary")
                ?.addEventListener("click", async () => {
                    await Promise.all([
                        container.unload({ unloadPopovers: false }),
                        // container.unloadPopover({ replaceNav: false })
                    ])
                    container.incrementStep()
                })
            modal.querySelector("button.secondary")
                ?.addEventListener("click", () => { container.unloadModal() })
            modalContainer.append(modal)
            container.loadModal(modalContainer)
        })

    await container.load(dummy, { unloadPopovers: false })
    container.loadPopover(popover)
    container.load(content, { unloadPopovers: false })
}, {
    id: "start-screen",
    title: "Start Quote",
    name: "Start",
    type: STEP_TYPES.start
})

// @@exports
export { startScreen }
